import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  fr: {
    // Navigation
    nav: {
      home: 'Accueil',
      services: 'Services',
      gallery: 'Galerie',
      about: 'À Propos',
      contact: 'Contact',
      login: 'Connexion',
      register: "S'inscrire",
      dashboard: 'Mon Espace',
      admin: 'Administration',
      logout: 'Déconnexion',
      book: 'Réserver',
    },
    // Hero
    hero: {
      overline: "L'EXCELLENCE ÉVÉNEMENTIELLE",
      title: 'Nûr Events',
      subtitle: 'Créateurs de moments lumineux',
      description: "Nous transformons vos visions en expériences inoubliables. Du mariage de vos rêves aux événements corporate d'exception.",
      cta: 'Découvrir nos services',
      ctaSecondary: 'Nous contacter',
    },
    // Services
    services: {
      overline: 'NOS PRESTATIONS',
      title: 'Services Premium',
      subtitle: 'Une expertise complète pour tous vos événements',
      viewAll: 'Voir tous les services',
      bookNow: 'Réserver maintenant',
      learnMore: 'En savoir plus',
      from: 'À partir de',
    },
    // Testimonials
    testimonials: {
      overline: 'TÉMOIGNAGES',
      title: 'Ils nous font confiance',
    },
    // Gallery
    gallery: {
      overline: 'PORTFOLIO',
      title: 'Nos Réalisations',
      viewAll: 'Voir la galerie complète',
    },
    // Contact
    contact: {
      overline: 'CONTACTEZ-NOUS',
      title: 'Parlons de votre projet',
      subtitle: 'Notre équipe est à votre écoute pour donner vie à vos événements',
      name: 'Votre nom',
      email: 'Votre email',
      phone: 'Téléphone',
      subject: 'Sujet',
      message: 'Votre message',
      send: 'Envoyer',
      success: 'Message envoyé avec succès',
      whatsapp: 'Contactez-nous sur WhatsApp',
    },
    // Footer
    footer: {
      tagline: "L'Excellence Événementielle en Afrique Centrale",
      services: 'Services',
      company: 'Entreprise',
      legal: 'Légal',
      privacy: 'Confidentialité',
      terms: 'Conditions',
      rights: 'Tous droits réservés',
    },
    // Auth
    auth: {
      loginTitle: 'Connexion',
      registerTitle: 'Créer un compte',
      email: 'Email',
      phone: 'Téléphone',
      password: 'Mot de passe',
      name: 'Nom complet',
      loginBtn: 'Se connecter',
      registerBtn: "S'inscrire",
      noAccount: 'Pas encore de compte ?',
      hasAccount: 'Déjà un compte ?',
      or: 'ou',
    },
    // Booking
    booking: {
      title: 'Réserver un service',
      eventDate: "Date de l'événement",
      eventType: "Type d'événement",
      guestCount: "Nombre d'invités",
      location: 'Lieu',
      notes: 'Notes supplémentaires',
      contactName: 'Nom du contact',
      contactEmail: 'Email',
      contactPhone: 'Téléphone',
      budgetRange: 'Budget estimé',
      submit: 'Confirmer la réservation',
      success: 'Réservation confirmée !',
      selectService: 'Sélectionnez un service',
      selectDate: 'Choisissez une date',
    },
    // Dashboard
    dashboard: {
      title: 'Mon Espace',
      welcome: 'Bienvenue',
      myBookings: 'Mes Réservations',
      noBookings: 'Aucune réservation pour le moment',
      status: 'Statut',
      date: 'Date',
      service: 'Service',
      amount: 'Montant',
    },
    // Statuses
    status: {
      pending: 'En attente',
      confirmed: 'Confirmé',
      cancelled: 'Annulé',
      completed: 'Terminé',
    },
    // Payment
    payment: {
      title: 'Paiement',
      selectMethod: 'Choisissez votre mode de paiement',
      stripe: 'Carte bancaire (Stripe)',
      mtnMomo: 'MTN Mobile Money',
      orangeMoney: 'Orange Money',
      proceed: 'Procéder au paiement',
      reference: 'Référence de paiement',
      instructions: 'Instructions',
    },
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      gallery: 'Gallery',
      about: 'About',
      contact: 'Contact',
      login: 'Login',
      register: 'Sign Up',
      dashboard: 'Dashboard',
      admin: 'Admin',
      logout: 'Logout',
      book: 'Book Now',
    },
    hero: {
      overline: 'EXCELLENCE IN EVENTS',
      title: 'Nûr Events',
      subtitle: 'Creators of luminous moments',
      description: 'We transform your visions into unforgettable experiences. From your dream wedding to exceptional corporate events.',
      cta: 'Discover our services',
      ctaSecondary: 'Contact us',
    },
    services: {
      overline: 'OUR SERVICES',
      title: 'Premium Services',
      subtitle: 'Complete expertise for all your events',
      viewAll: 'View all services',
      bookNow: 'Book now',
      learnMore: 'Learn more',
      from: 'From',
    },
    testimonials: {
      overline: 'TESTIMONIALS',
      title: 'They trust us',
    },
    gallery: {
      overline: 'PORTFOLIO',
      title: 'Our Work',
      viewAll: 'View full gallery',
    },
    contact: {
      overline: 'CONTACT US',
      title: "Let's discuss your project",
      subtitle: 'Our team is here to bring your events to life',
      name: 'Your name',
      email: 'Your email',
      phone: 'Phone',
      subject: 'Subject',
      message: 'Your message',
      send: 'Send',
      success: 'Message sent successfully',
      whatsapp: 'Contact us on WhatsApp',
    },
    footer: {
      tagline: 'Excellence in Events in Central Africa',
      services: 'Services',
      company: 'Company',
      legal: 'Legal',
      privacy: 'Privacy',
      terms: 'Terms',
      rights: 'All rights reserved',
    },
    auth: {
      loginTitle: 'Login',
      registerTitle: 'Create Account',
      email: 'Email',
      phone: 'Phone',
      password: 'Password',
      name: 'Full Name',
      loginBtn: 'Sign In',
      registerBtn: 'Sign Up',
      noAccount: "Don't have an account?",
      hasAccount: 'Already have an account?',
      or: 'or',
    },
    booking: {
      title: 'Book a Service',
      eventDate: 'Event Date',
      eventType: 'Event Type',
      guestCount: 'Number of Guests',
      location: 'Location',
      notes: 'Additional Notes',
      contactName: 'Contact Name',
      contactEmail: 'Email',
      contactPhone: 'Phone',
      budgetRange: 'Estimated Budget',
      submit: 'Confirm Booking',
      success: 'Booking confirmed!',
      selectService: 'Select a service',
      selectDate: 'Choose a date',
    },
    dashboard: {
      title: 'Dashboard',
      welcome: 'Welcome',
      myBookings: 'My Bookings',
      noBookings: 'No bookings yet',
      status: 'Status',
      date: 'Date',
      service: 'Service',
      amount: 'Amount',
    },
    status: {
      pending: 'Pending',
      confirmed: 'Confirmed',
      cancelled: 'Cancelled',
      completed: 'Completed',
    },
    payment: {
      title: 'Payment',
      selectMethod: 'Choose your payment method',
      stripe: 'Credit Card (Stripe)',
      mtnMomo: 'MTN Mobile Money',
      orangeMoney: 'Orange Money',
      proceed: 'Proceed to Payment',
      reference: 'Payment Reference',
      instructions: 'Instructions',
    },
  },
  ar: {
    nav: {
      home: 'الرئيسية',
      services: 'الخدمات',
      gallery: 'المعرض',
      about: 'عنا',
      contact: 'اتصل بنا',
      login: 'تسجيل الدخول',
      register: 'إنشاء حساب',
      dashboard: 'لوحة التحكم',
      admin: 'الإدارة',
      logout: 'تسجيل الخروج',
      book: 'احجز الآن',
    },
    hero: {
      overline: 'التميز في الفعاليات',
      title: 'نور إيفنتس',
      subtitle: 'صانعو اللحظات المضيئة',
      description: 'نحول رؤاك إلى تجارب لا تُنسى. من حفل زفاف أحلامك إلى الفعاليات المؤسسية الاستثنائية.',
      cta: 'اكتشف خدماتنا',
      ctaSecondary: 'تواصل معنا',
    },
    services: {
      overline: 'خدماتنا',
      title: 'خدمات فاخرة',
      subtitle: 'خبرة شاملة لجميع فعالياتك',
      viewAll: 'عرض جميع الخدمات',
      bookNow: 'احجز الآن',
      learnMore: 'اعرف المزيد',
      from: 'من',
    },
    testimonials: {
      overline: 'الشهادات',
      title: 'يثقون بنا',
    },
    gallery: {
      overline: 'معرض الأعمال',
      title: 'أعمالنا',
      viewAll: 'عرض المعرض الكامل',
    },
    contact: {
      overline: 'اتصل بنا',
      title: 'دعنا نتحدث عن مشروعك',
      subtitle: 'فريقنا هنا لإحياء فعالياتك',
      name: 'اسمك',
      email: 'بريدك الإلكتروني',
      phone: 'الهاتف',
      subject: 'الموضوع',
      message: 'رسالتك',
      send: 'إرسال',
      success: 'تم إرسال الرسالة بنجاح',
      whatsapp: 'تواصل معنا عبر واتساب',
    },
    footer: {
      tagline: 'التميز في الفعاليات في وسط أفريقيا',
      services: 'الخدمات',
      company: 'الشركة',
      legal: 'قانوني',
      privacy: 'الخصوصية',
      terms: 'الشروط',
      rights: 'جميع الحقوق محفوظة',
    },
    auth: {
      loginTitle: 'تسجيل الدخول',
      registerTitle: 'إنشاء حساب',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      password: 'كلمة المرور',
      name: 'الاسم الكامل',
      loginBtn: 'دخول',
      registerBtn: 'تسجيل',
      noAccount: 'ليس لديك حساب؟',
      hasAccount: 'لديك حساب بالفعل؟',
      or: 'أو',
    },
    booking: {
      title: 'حجز خدمة',
      eventDate: 'تاريخ الفعالية',
      eventType: 'نوع الفعالية',
      guestCount: 'عدد الضيوف',
      location: 'الموقع',
      notes: 'ملاحظات إضافية',
      contactName: 'اسم جهة الاتصال',
      contactEmail: 'البريد الإلكتروني',
      contactPhone: 'الهاتف',
      budgetRange: 'الميزانية المقدرة',
      submit: 'تأكيد الحجز',
      success: 'تم تأكيد الحجز!',
      selectService: 'اختر خدمة',
      selectDate: 'اختر تاريخاً',
    },
    dashboard: {
      title: 'لوحة التحكم',
      welcome: 'مرحباً',
      myBookings: 'حجوزاتي',
      noBookings: 'لا توجد حجوزات حتى الآن',
      status: 'الحالة',
      date: 'التاريخ',
      service: 'الخدمة',
      amount: 'المبلغ',
    },
    status: {
      pending: 'قيد الانتظار',
      confirmed: 'مؤكد',
      cancelled: 'ملغي',
      completed: 'مكتمل',
    },
    payment: {
      title: 'الدفع',
      selectMethod: 'اختر طريقة الدفع',
      stripe: 'بطاقة ائتمان (Stripe)',
      mtnMomo: 'MTN Mobile Money',
      orangeMoney: 'Orange Money',
      proceed: 'متابعة الدفع',
      reference: 'مرجع الدفع',
      instructions: 'التعليمات',
    },
  },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('nur_language');
    return saved || 'fr';
  });

  const [dir, setDir] = useState(language === 'ar' ? 'rtl' : 'ltr');

  useEffect(() => {
    localStorage.setItem('nur_language', language);
    const newDir = language === 'ar' ? 'rtl' : 'ltr';
    setDir(newDir);
    document.documentElement.setAttribute('dir', newDir);
    document.documentElement.setAttribute('lang', language);
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const getLocalizedField = (obj, fieldPrefix) => {
    if (!obj) return '';
    return obj[`${fieldPrefix}_${language}`] || obj[`${fieldPrefix}_en`] || obj[`${fieldPrefix}_fr`] || '';
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, dir, getLocalizedField }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
